/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ServiceLandingCountryCodeEnum =
  (typeof ServiceLandingCountryCodeEnum)[keyof typeof ServiceLandingCountryCodeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceLandingCountryCodeEnum = {
  US: 'US',
  CA: 'CA',
  GB: 'GB',
  DE: 'DE',
  ES: 'ES',
  FR: 'FR',
  IT: 'IT',
  NL: 'NL',
  NO: 'NO',
  SE: 'SE',
  DK: 'DK',
  IE: 'IE',
  PL: 'PL',
  CH: 'CH',
  FI: 'FI',
  AT: 'AT',
  BE: 'BE',
} as const;
